<script>
import ProductForm from '~/components/product-form'
import ProductMixin from '~/mixins/product.mixin'

export default {
  name: 'ProviderProductForm',
  components: {
    ProductForm,
  },
  mixins: [ProductMixin],
  props: {
    providerId: {
      type: String,
      default: '',
    },
    providerProductId: {
      type: String,
      default: '',
    },
  },
  computed: {
    formComponent() {
      return this.$refs.productForm
    },
  },
}
</script>

<template>
  <product-form
    ref="productForm"
    :provider-id="providerId"
    :provider-product-id="providerProductId"
    :back-to="{ name:'provider-product', params: { id: providerId } }"
    title="Edit Provider Product"
    is-edit
    type="provider"
  />
</template>
